/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { Text } from '@lib/canvasx/components/Text';
import { type FieldContentsData } from '../../shared-types';
import { canvasCssValue } from '@lib/canvasx/util';

export const TextField: CanvaSXFC<{
  contents: FieldContentsData;
  fieldId: RecordId;
  text: string | number;
}> = function ({ text, contents, fieldId }) {
  let key: string | undefined;
  let clickHandler: CanvaSXIntrinsicProps['onClick'];

  const { object } = CanvaSX.context;
  const { controller } = object;

  const { recordRef } = contents;
  if (recordRef && controller) {
    key = `link:${fieldId}`;
    clickHandler = (fabricMouseEvent: { e: MouseEvent }) => {
      if (fabricMouseEvent.e.button !== 0) {
        return; // Only handle left-clicks
      }
      controller.openRecordInDrawer(recordRef);
    };
  }

  let textColorVar = contents.titleStyle
    ? '--theme-primary-text'
    : '--theme-secondary-text';
  let textColorFallback = contents.titleStyle ? '#333333' : '#666666';
  if (key && object?.hoveredKey === key) {
    textColorVar = '--theme-link-text';
    textColorFallback = '#0073cf';
  }

  return (
    <Text
      key={key}
      size={contents.titleStyle ? 14 : 11}
      color={canvasCssValue(textColorVar, textColorFallback)}
      lineHeight={1.4}
      onClick={clickHandler}
    >
      {text}
    </Text>
  );
};
